import React from 'react';

import Score from '../Score/Score';

const ScoreView = ({ category }) => {
  if (category.value === category.initialValue) {
    return <Score key={category.title} value={category.value} />;
  }
  return (
    <div className="diagnostic-category-score">
      <Score
        key={`${category.title}-initial`}
        value={category.initialValue}
        scoreType="Initial"
      />
      <Score
        key={`${category.title}-adjusted`}
        value={category.value}
        scoreType="Adjusted"
      />
    </div>
  );
};

export default ScoreView;
